const DRIVING_VEHICLE_FUEL_EFFICIENCY_IN_KM_PER_L_MAP = {
    'light': 20,
    'medium': 15,
    'large': 10
}

export {
    DRIVING_VEHICLE_FUEL_EFFICIENCY_IN_KM_PER_L_MAP
}